'use client';

import { useEffect } from 'react';

interface thirdPartyFormProps {
  formData?: {
    _type: 'thirdPartyForms';
    _key: string;
    code: {
      _type: 'code';
      code: string;
    };
    background?: {
      type?: 'image' | 'none';
      image?: {
        asset?: {
          _ref: string;
          _type: 'reference';
        };
      } | null;
    };
  };
}

export default function ThirdPartyForm({ formData }: thirdPartyFormProps) {
  useEffect(() => {
    if (!formData?.code?.code) return;

    // Parse the code string to extract the script elements
    const parser = new DOMParser();
    const doc = parser.parseFromString(formData.code.code, 'text/html');

    // Handle script tag
    const scripts = doc.querySelectorAll('script');
    scripts.forEach((originalScript) => {
      const script = document.createElement('script');
      if (originalScript.src) {
        script.src = originalScript.src;
      }
      if (originalScript.innerHTML) {
        script.innerHTML = originalScript.innerHTML;
      }
      script.defer = true;
      document.body.appendChild(script);
    });

    // Cleanup on unmount
    return () => {
      // Remove all scripts we added
      scripts.forEach(() => {
        const addedScript = document.querySelector(
          `script[src="${scripts[0]?.src}"]`
        );
        if (addedScript) {
          document.body.removeChild(addedScript);
        }
      });
    };
  }, [formData]);

  if (!formData?.code?.code) {
    return null;
  }

  return (
    <div
      dangerouslySetInnerHTML={{
        __html: formData.code.code,
      }}
    />
  );
}
